import React from 'react';
import PropTypes from 'prop-types';
import { Clock } from '../../../../assets/images/index';

import { StyleUpdate, StyleUpdateIcon } from './style';

const WidgetMiniUpdate = ({ update, onInfo }) => (
  <StyleUpdate className="WidgetMiniUpdate">
    {update}
    <StyleUpdateIcon svg={Clock} size="s" color="dark" hover onClick={onInfo} />
  </StyleUpdate>
);

WidgetMiniUpdate.propTypes = {
  onInfo: PropTypes.func,
  update: PropTypes.string
};

export default WidgetMiniUpdate;
